import { api } from './api'
import { makeFilter, mergeFilters, equals, createParams } from '@/utils/dynamic'

export const createBaseEndpoints = (apiPath) => {
  return {
    apiGet: `${apiPath}/Get`,
    apiGetDynamic: `${apiPath}/GetAllDynamic`,
    apiPost: `${apiPath}/Create`,
    apiPatch: `${apiPath}/Patch`,
    apiPut: `${apiPath}/Put`,
    apiDelete: `${apiPath}/Delete`
  }
}
export class ServiceError extends Error {
}
export class Service {
  constructor ({ apiGet, apiGetDynamic, apiPost, apiPatch, apiPut, apiDelete }) {
    this.apiGet = apiGet
    this.apiGetDynamic = apiGetDynamic
    this.apiPost = apiPost
    this.apiPatch = apiPatch
    this.apiDelete = apiDelete
  }
  async get (id) {
    return api
      .get(`${this.apiGet}/${id}`)
  }
  async getAllDynamic (params) {
    params = createParams(params)
    return api
      .get(`${this.apiGetDynamic}`, { params })
  }
  async getDynamic (id, params) {
    params = createParams(params)
    params.filter = mergeFilters(params.filter, makeFilter('id', id, equals)).join('&&')

    return this.getAllDynamic(params)
      .then((response) => {
        const result = response.data.value[0]
        if (result) {
          return { data: result }
        } else {
          throw new Error('Not found record')
        }
      })
  }
  async post (data) {
    const _data = { ...data }
    delete _data['id']

    return api
      .post(`${this.apiPost}`, _data)
  }
  async patch (data) {
    const { id, ...rest } = data

    if (!id) {
      console.error(`Service => Id is required`)
      throw new Error('Something went wrong')
    }

    return api.patch(`${this.apiPatch}/${id}`, rest)
  }
  async delete (id) {
    return api.delete(`${this.apiDelete}/${id}`)
  }
}

export class ServiceWithRFQID extends Service {
  async getByRFQID (rfqid, params) {
    const _params = createParams(params || {})

    _params.filter = mergeFilters(_params.filter, makeFilter('rfqid', rfqid, equals)).join('&&')

    return this.getAllDynamic(_params)
      .then(({ data }) => {
        const _data = data.value[0]
        if (!_data) {
          throw new Error(`Record with ${rfqid} is not found`)
        }
        return { data: _data }
      })
  }
}
